import useParticipants from "hooks/livekit/useParticipants/useParticipants";
import ParticipantTracks from "components/pages/Session/shared/ParticipantTracks/ParticipantTracks";

export const TTSParticipant = () => {
  const participants = useParticipants();
  const tts = participants.find((p) => p.identity.includes("observer"));
  return <>{tts && <ParticipantTracks participant={tts} />}</>;
};
